/* WNF list page (wnf-wishlist-2026-10-07). Renders the saved list or a shared ?items= list with live price and stock.
   Needs wnf-wishlist.js (window.WNFWL.api). Data per piece: /products/<handle>?view=wishlist-data. */
(function (d) {
  var root = d.getElementById('wnf-wl-page');
  if (!root) return;
  var cache = {}, similarP = null, shared = null;

  function api() { return window.WNFWL && window.WNFWL.api; }
  function $(id) { return d.getElementById(id); }
  function parseShared() {
    var m = /[?&]items=([^&#]+)/.exec(location.search);
    if (!m) return null;
    return decodeURIComponent(m[1]).split(',').map(function (p) {
      var a = p.split(':');
      return { h: (a[0] || '').replace(/[^a-z0-9\-]/gi, '').toLowerCase(), v: +(a[1] || 0) };
    }).filter(function (x) { return x.h; }).slice(0, 40);
  }
  function load(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=wishlist-data', { credentials: 'same-origin' })
      .then(function (r) { return r.status === 404 ? { gone: 1 } : r.ok ? r.text().then(function (t) { try { return JSON.parse(t); } catch (e) { return { err: 1 }; } }) : { err: 1 }; })
      .catch(function () { return { err: 1 }; });
    return cache[h];
  }
  /* Similar pieces for a sold consignment: same category tag, then a shared category word (TABLES, CHAIRS...), then title words. */
  function similar(cat, title) {
    similarP = similarP || fetch(root.getAttribute('data-similar'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { return j.products || []; }).catch(function () { return []; });
    var stop = /^(CONSIGNED|AND|WITH|THE|SET|OF|VINTAGE|USED|MID|CENTURY|MODERN)$/;
    var cw = String(cat || '').toUpperCase().split(/[^A-Z]+/).filter(function (w) { return w.length > 2 && !stop.test(w); });
    var tw = String(title || '').toUpperCase().replace(/\(.*?\)/g, '').split(/[^A-Z]+/).filter(function (w) { return w.length > 3 && !stop.test(w); });
    return similarP.then(function (ps) {
      return ps.filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }).map(function (p, i) {
        var tags = (p.tags || []).join(' ').toUpperCase(), tt = String(p.title || '').toUpperCase(), sc = 0;
        if (cat && (p.tags || []).indexOf(cat) > -1) sc += 6;
        cw.forEach(function (w) { if (tags.indexOf(w) > -1) sc += 3; });
        tw.forEach(function (w) { if (tt.indexOf(w) > -1) sc += 2; });
        return { p: p, sc: sc, i: i };
      }).sort(function (a, b) { return b.sc - a.sc || a.i - b.i; }).slice(0, 3).map(function (x) { return x.p; });
    });
  }
  function dateTxt(s) {
    if (!s) return '';
    var t = new Date(s + 'T12:00:00');
    return isNaN(t) ? '' : t.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function img(src, w) { return src ? String(src).replace(/^\/\//, 'https://').replace(/([?&])width=\d+/, '$1') + (String(src).indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  /* wnf-wishlist-crop-2026-10-08: which photo a tile shows, and how. "c"/"ci" from the data template are the collection
     card photo as "mode|url" (b baked cutout, c studio crop, p lifestyle). A variant's own photo is a lifestyle shot by
     convention (fills the tile) unless it is the featured photo; a featured or snapshot photo is a studio shot
     (contained, never cropped). */
  function pic(v, p, it) {
    var c = (v && v.c) || '';
    if (!c && v && v.i) c = (p && v.i === p.i ? 'c|' : 'p|') + v.i;
    if (!c && p) c = p.ci || (p.i ? 'c|' + p.i : '');
    if (!c && it && it.i) c = 'c|' + it.i;
    var k = c.indexOf('|');
    return k > 0 ? { m: c.slice(0, k), u: c.slice(k + 1) } : { m: 'c', u: '' };
  }
  function tile(ph, w, alt) { var E = api().esc; return ph.u ? '<img src="' + E(img(ph.u, w)) + '" alt="' + E(alt || '') + '" loading="lazy" decoding="async" width="' + w + '" height="' + w + '">' : ''; }

  /* Status line for one saved piece: {dot, strong, sub, v, floor: [store keys with this piece in any color], sold}. */
  function status(it, p, A) {
    if (p.gone || (p.k && !p.a)) return it.k || p.k ? { sold: 1 } : { dot: 'off', strong: 'No longer available.', sub: 'Ask us about something similar.' };
    if (p.err) return { dot: 'off', strong: 'We could not load this piece.', sub: 'Refresh to try again.' };
    var v = null;
    p.v.forEach(function (x) { if (String(x.id) === String(it.v)) v = x; });
    var swapped = !v && it.v;
    v = v || p.v[0];
    var fl = A.floors(p.v, v.id), exact = [], alt = '', here = [];
    fl.forEach(function (f) {
      if (f.on) here.push(f.s.k);
      if (f.on === 1) exact.push(f.s.n === 'Portland' ? 'in Portland' : 'at Cedar Mill');
      if (f.on === 2 && !alt) alt = 'Sit in it ' + (f.s.n === 'Portland' ? 'in Portland' : 'at Cedar Mill') + '. The floor model is ' + f.txt.replace('Floor model in ', '') + '.';
    });
    var out = { v: v, floor: here };
    if (v.s === 'in_stock' && exact.length) { out.dot = 'ok'; out.strong = 'On the floor ' + exact.join(' and ') + '.'; out.sub = v.o ? 'This exact color is in the showroom today.' : ''; }
    else if (v.s === 'in_stock') { out.dot = 'ok'; out.strong = 'In stock.'; out.sub = alt || 'Confirm delivery or pickup timing with our team.'; }
    else if (v.s === 'soon') { out.dot = 'soon'; out.strong = 'Arriving soon' + (v.eta ? ', around ' + dateTxt(v.eta) : '') + '.'; out.sub = alt; }
    else if (v.s === 'order') { out.dot = 'soon'; out.strong = 'Made to order.'; out.sub = alt || 'Ask us about lead time and samples.'; }
    else if (v.a) { out.dot = 'ok'; out.strong = 'Available to order.'; out.sub = alt; }
    else { out.dot = 'off'; out.strong = 'Not available right now.'; out.sub = 'Ask us when it is back.'; }
    if (swapped) out.sub = 'The option you saved is no longer offered. ' + (out.sub || '');
    return out;
  }

  function row(it, p, st, A, mine) {
    var E = A.esc, v = st.v, title = p.t || it.t || it.h, url = (p.u || '/products/' + it.h) + (v ? '?variant=' + v.id : '');
    var vt = v ? (v.o || A.short(v.t)) : (it.vt || ''), dims = (v && v.d) || p.dims || '';
    var ph = pic(v, p, it);
    var act = mine
      ? (v && v.a && !st.sold ? '<button type="button" class="wnf-wl-btn" data-wl-cart="' + v.id + '">Add to cart</button>' : '') + '<button type="button" class="wnf-wl-link" data-wl-remove>Remove</button>'
      : '<button type="button" class="wnf-wl-heart wnf-wl-heart--inline" data-wnf-wl="' + E(it.h) + '" data-v="' + (v ? v.id : it.v) + '" data-place="pdp-shared" data-name="' + E(title) + '" aria-pressed="false" aria-label="Save ' + E(title) + ' to your list"><span class="wnf-wl-heart__chip"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg></span></button>';
    var price = v ? A.money(v.p) : (it.p ? A.money(it.p) : '');
    var drop = mine && v && it.p && it.p > v.p ? '<span class="wnf-wl-chip">' + 'Down ' + A.money(it.p - v.p) + ' since you saved</span>' : '';
    if (st.sold) {
      return '<li class="wnf-wl-item is-sold" data-h="' + E(it.h) + '" data-v="' + it.v + '">' +
        '<div class="wnf-wl-item__img wnf-wl-pic is-c">' + tile(pic(null, null, it), 400, title + ', sold') + '<span class="wnf-wl-sold">Sold</span></div>' +
        '<div class="wnf-wl-item__body"><div class="wnf-wl-item__title">' + E(title) + '</div>' +
        '<div class="wnf-wl-item__dims">Consignment' + (it.p ? ' · was ' + A.money(it.p) : '') + '</div>' +
        '<p class="wnf-wl-item__note">Someone took this one home. Consignment pieces are one of a kind, so here are similar pieces on our floor now.</p>' +
        '<div class="wnf-wl-similar" data-cat="' + E(it.c || '') + '" data-title="' + E(title) + '"></div></div>' +
        '<div class="wnf-wl-item__side">' + (mine ? '<button type="button" class="wnf-wl-link" data-wl-remove>Remove</button>' : '') + '</div></li>';
    }
    return '<li class="wnf-wl-item" data-h="' + E(it.h) + '" data-v="' + (v ? v.id : it.v) + '">' +
      '<a class="wnf-wl-item__img wnf-wl-pic is-' + ph.m + '" href="' + E(url) + '" tabindex="-1" aria-hidden="true">' + tile(ph, 400, '') + '</a>' +
      '<div class="wnf-wl-item__body"><a class="wnf-wl-item__title" href="' + E(url) + '">' + E(title) + '</a>' +
      (vt ? '<div class="wnf-wl-item__var">' + E(vt) + '</div>' : '') + (dims ? '<div class="wnf-wl-item__dims">' + E(dims) + '</div>' : '') +
      '<div class="wnf-wl-item__status"><span class="wnf-wl-dot wnf-wl-dot--' + st.dot + '" aria-hidden="true"></span><span><strong>' + E(st.strong) + '</strong>' + (st.sub ? ' <span>' + E(st.sub) + '</span>' : '') + '</span></div>' +
      (mine && it.d ? '<div class="wnf-wl-item__saved">Saved ' + dateTxt(it.d) + (it.p ? ' at ' + A.money(it.p) : '') + '</div>' : '') + '</div>' +
      '<div class="wnf-wl-item__side"><div class="wnf-wl-item__price">' + price + '</div>' + drop + act + '</div></li>';
  }

  function visitPanel(rows, A) {
    var box = $('wnf-wl-visit');
    if (!box) return;
    var per = { grand_showroom: [], murray_showroom: [] }, any = 0;
    rows.forEach(function (r) {
      if (!r.st.floor || !r.st.floor.length) return;
      any++;
      r.st.floor.forEach(function (k) { if (per[k]) per[k].push(r); });
    });
    var whose = shared ? 'these' : 'your';
    $('wnf-wl-visit-h').textContent = any ? (any === 1 ? '1 of ' + whose + ' pieces is' : any + ' of ' + whose + ' pieces are') + ' on a showroom floor right now.' : 'See the fabrics, finishes and similar pieces in person.';
    var hrs = A.hours();
    A.stores.forEach(function (s) {
      var el = root.querySelector('[data-store="' + s.k + '"]');
      if (!el) return;
      var list = per[s.k], th = el.querySelector('[data-store-thumbs]'), ct = el.querySelector('[data-store-count]'), hr = el.querySelector('[data-store-hours]');
      if (hr) hr.textContent = hrs;
      if (ct) ct.innerHTML = list.length ? '<strong>' + list.length + (list.length === 1 ? ' piece' : ' pieces') + '</strong> ' + (shared ? 'from this list' : 'from your list') + ' to sit in' : 'None of ' + whose + ' pieces on this floor today';
      if (th) th.innerHTML = list.slice(0, 4).map(function (r) { var ph = pic(r.st.v, r.p, r.it); return ph.u ? '<span class="wnf-wl-pic is-' + ph.m + '">' + tile(ph, 120, '') + '</span>' : ''; }).join('');
    });
    box.hidden = false;
  }

  function render() {
    var A = api();
    if (!A) return setTimeout(render, 50);
    var mine = !shared, items = shared || A.read(), list = $('wnf-wl-items'), empty = $('wnf-wl-empty'), sub = $('wnf-wl-sub');
    root.classList.toggle('is-shared', !mine);
    if (!items.length) {
      list.innerHTML = ''; empty.hidden = false; $('wnf-wl-visit').hidden = true; root.classList.add('is-empty');
      if (sub) sub.textContent = '';
      return;
    }
    root.classList.remove('is-empty'); empty.hidden = true;
    if (sub) sub.textContent = mine ? items.length + (items.length === 1 ? ' piece' : ' pieces') + ', saved on this device. Prices and stock are checked each time you open this page.' : '';
    if (!mine && $('wnf-wl-h1')) $('wnf-wl-h1').textContent = 'A list shared with you';
    if (!list.children.length) list.innerHTML = items.map(function () { return '<li class="wnf-wl-item is-loading" aria-hidden="true"><div class="wnf-wl-item__img"></div><div class="wnf-wl-item__body"></div></li>'; }).join('');
    Promise.all(items.map(function (it) { return load(it.h).then(function (p) { return { it: it, p: p, st: status(it, p, A) }; }); })).then(function (rows) {
      list.innerHTML = rows.map(function (r) { return row(r.it, r.p, r.st, A, mine); }).join('');
      if (mine) {
        /* Backfill a snapshot the save could not fetch, so a later sold or removed piece still shows its photo and name. */
        var cur = A.read(), dirty = false;
        rows.forEach(function (r) {
          if (r.it.t || !r.st.v || !r.p.v) return;
          var i = A.find(cur, r.it.h, r.it.v);
          if (i < 0) return;
          var v = r.st.v;
          cur[i].pid = r.p.id; cur[i].t = r.p.t; cur[i].vt = v.o || A.short(v.t); cur[i].i = v.i || r.p.i; cur[i].k = r.p.k ? 1 : 0; cur[i].c = r.p.c || '';
          if (!cur[i].p) cur[i].p = v.p;
          dirty = true;
        });
        if (dirty) A.write(cur);
      }
      list.setAttribute('aria-busy', 'false');
      visitPanel(rows, A);
      [].forEach.call(list.querySelectorAll('.wnf-wl-similar'), function (box) {
        similar(box.getAttribute('data-cat'), box.getAttribute('data-title')).then(function (ps) {
          box.innerHTML = ps.map(function (p) {
            var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
            var ph = { m: 'c', u: p.images && p.images[0] ? p.images[0].src : '' };
            return '<div class="wnf-wl-sim"><a href="/products/' + A.esc(p.handle) + '"><span class="wnf-wl-sim__img wnf-wl-pic is-c">' + tile(ph, 300, '') + '</span><span class="wnf-wl-sim__t">' + A.esc(p.title) + '</span><span>' + A.money(Math.round(parseFloat(v.price) * 100)) + '</span></a>' +
              '<button type="button" class="wnf-wl-heart" data-wnf-wl="' + A.esc(p.handle) + '" data-v="' + v.id + '" data-place="list-similar" data-name="' + A.esc(p.title) + '" aria-pressed="false" aria-label="Save ' + A.esc(p.title) + ' to your list"><span class="wnf-wl-heart__chip"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg></span></button></div>';
          }).join('');
          A.sync();
        });
      });
      A.sync();
      if (!mine) sharedBanner(rows, A);
    });
  }

  function sharedBanner(rows, A) {
    var box = $('wnf-wl-shared'), mineList = A.read(), n = 0;
    if (!box) return;
    rows.forEach(function (r) { if (!r.st.sold && A.find(mineList, r.it.h, r.st.v ? r.st.v.id : r.it.v) < 0) n++; });
    box.hidden = false;
    $('wnf-wl-shared-h').textContent = 'Someone picked ' + rows.length + (rows.length === 1 ? ' piece' : ' pieces') + ' for you to see.';
    var btn = $('wnf-wl-saveall');
    btn.textContent = n ? 'Save ' + (n === rows.length ? 'all ' : '') + n + ' to my list' : 'All saved to your list';
    btn.disabled = !n;
    btn.onclick = function () {
      var list = A.read(), added = [];
      rows.forEach(function (r) {
        if (r.st.sold || !r.st.v) return;
        if (A.find(list, r.it.h, r.st.v.id) > -1) return;
        var e = { h: r.it.h, v: r.st.v.id, d: A.today(), pid: r.p.id, t: r.p.t, vt: r.st.v.o || A.short(r.st.v.t), p: r.st.v.p, i: r.st.v.i || r.p.i, k: r.p.k ? 1 : 0, c: r.p.c || '' };
        list.push(e); added.push(e);
      });
      A.write(list);
      if (added.length) A.ga(added, 'shared-save-all');
      btn.textContent = 'Saved. Open your list';
      btn.disabled = false;
      btn.onclick = function () { location.href = root.getAttribute('data-list'); };
    };
  }

  function shareUrl(A) {
    return location.origin + root.getAttribute('data-list') + '?items=' + A.read().map(function (it) { return it.h + (it.v ? ':' + it.v : ''); }).join(',');
  }

  root.addEventListener('click', function (e) {
    var A = api(), t = e.target;
    if (!A || !t.closest) return;
    var li = t.closest('.wnf-wl-item');
    if (t.closest('[data-wl-remove]') && li) { A.remove(li.getAttribute('data-h'), li.getAttribute('data-v') === '0' ? null : li.getAttribute('data-v')); return; }
    var cart = t.closest('[data-wl-cart]');
    if (cart) {
      cart.disabled = true; cart.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +cart.getAttribute('data-wl-cart'), quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          cart.disabled = false;
          cart.textContent = res.ok ? 'Added to cart' : 'Could not add';
          if (res.ok) d.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.j }, bubbles: true }));
        }).catch(function () { cart.disabled = false; cart.textContent = 'Could not add'; });
      return;
    }
    if (t.closest('[data-wl-print]')) { window.print(); return; }
    var sh = t.closest('[data-wl-share]');
    if (sh) {
      var url = shareUrl(A), msg = $('wnf-wl-share-msg');
      if (navigator.share && /Mobi|Android|iPhone|iPad/.test(navigator.userAgent)) { navigator.share({ title: 'My list from What\'s New Furniture', url: url }).catch(function () {}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { if (msg) msg.textContent = 'Link copied. Anyone with it sees this list.'; })
        .catch(function () { if (msg) msg.innerHTML = 'Copy this link: <input readonly value="' + A.esc(url) + '" onclick="this.select()">'; });
    }
  });

  var pr = root.querySelector('[data-wl-printed]');
  if (pr) pr.textContent = 'Printed ' + new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + '.';
  shared = parseShared();
  d.addEventListener('wnf:wl', function () { if (!shared) render(); });
  d.addEventListener('wnf:wl-import', function () { if (!shared) render(); });
  render();
})(document);
